import type { BetterstartIntegrationDefinition } from '@cli-types/integration-engine/integrations.js'

export function isProviderIntegration(definition: BetterstartIntegrationDefinition): boolean {
  return Boolean(definition.capabilities?.emailProvider || definition.capabilities?.storageProvider)
}
